var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavePage404Top(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 136,
    viewBox: "0 0 320 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.095 108.068L309.422 101.323C298.75 94.5781 277.405 81.0884 256.071 81.1071C234.738 81.1259 213.417 94.6532 192.081 92.4346C170.746 90.0472 149.397 72.3361 128.053 60.9571C106.71 49.5781 85.3731 45.3755 64.0396 45.2676C42.7064 45.413 21.3768 49.6532 10.7123 52.0688L0.0475775 54.3155L7.37781e-06 0.281628L10.6667 0.272237C21.3333 0.262846 42.6667 0.244065 64 0.225284C85.3333 0.206502 106.667 0.187721 128 0.16894C149.333 0.150158 170.667 0.131377 192 0.112596C213.333 0.0938144 234.667 0.0750331 256 0.0562517C277.333 0.0374704 298.667 0.0186891 309.333 0.00929842L320 -9.22397e-05L320.095 108.068Z",
    fill: "#66BCE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 135.085,
    fill: "white",
    transform: "translate(320.119 135.085) rotate(179.95)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavePage404Top);
export default __webpack_public_path__ + "static/media/wavePage404Top.953d070b4b5581bb3b98518b318b9790.svg";
export { ForwardRef as ReactComponent };